module.exports = "<h2>Subscription Status</h2>\n<user-info></user-info>\n\n<h2>Machine Status</h2>\n<machine-list></machine-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.html
// module id = ./src/app/components/dashboard/dashboard.html
// module chunks = main